/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import { css, styled } from '@superset-ui/core';

/** Shared ghost chip metrics (Explore header metadata + chart stat pills). */
export const GHOST_CHIP_MIN_HEIGHT = 28;
export const GHOST_CHIP_PADDING_Y = 5;
export const GHOST_CHIP_PADDING_X = 10;
export const GHOST_CHIP_FONT_SIZE = 12;

export const ghostTooltipTriggerStyle = css`
  display: inline-flex;
  vertical-align: middle;
  line-height: 0;
  flex-shrink: 0;

  &.ant-tooltip-open {
    display: inline-flex !important;
  }

  &.ant-tooltip-open::after {
    content: none !important;
    display: none !important;
  }
`;

export const GhostTooltipTrigger = styled.span`
  ${ghostTooltipTriggerStyle}
`;
